var _rect, _g, _path, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustrationCloudSpace(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 300,
    viewBox: "0 0 480 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_44_536",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 480,
    height: 300
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 480,
    height: 300,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_44_536)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.809 91.1192C290.106 91.1192 330.881 131.894 330.881 182.191C330.881 232.489 290.106 273.263 239.809 273.263C189.511 273.263 148.737 232.489 148.737 182.191C148.737 131.894 189.511 91.1192 239.809 91.1192ZM239.809 115.817C203.151 115.817 173.434 145.534 173.434 182.191C173.434 218.849 203.151 248.566 239.809 248.566C276.466 248.566 306.183 218.849 306.183 182.191C306.183 145.534 276.466 115.817 239.809 115.817Z",
    fill: "url(#paint0_linear_44_536)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.809 52.8381C311.249 52.8381 369.162 110.751 369.162 182.191C369.162 253.631 311.249 311.545 239.809 311.545C168.369 311.545 110.456 253.631 110.456 182.191C110.456 110.751 168.369 52.8381 239.809 52.8381ZM239.809 77.5356C182.009 77.5356 135.153 124.392 135.153 182.191C135.153 239.991 182.009 286.847 239.809 286.847C297.608 286.847 344.464 239.991 344.464 182.191C344.464 124.392 297.608 77.5356 239.809 77.5356Z",
    fill: "url(#paint1_linear_44_536)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.5 9C335.321 9 413 86.6786 413 182.5C413 278.321 335.321 356 239.5 356C143.679 356 66 278.321 66 182.5C66 86.6786 143.679 9 239.5 9ZM239.5 33.6975C157.319 33.6975 90.6975 100.319 90.6975 182.5C90.6975 264.681 157.319 331.302 239.5 331.302C321.681 331.302 388.302 264.681 388.302 182.5C388.302 100.319 321.681 33.6975 239.5 33.6975Z",
    fill: "url(#paint2_linear_44_536)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149 153H195.608C196.995 153 198.321 153.577 199.266 154.592L210.922 167.106C211.489 167.716 212.284 168.062 213.117 168.062H314.408C315.928 168.062 317.208 169.199 317.387 170.709L329.335 271.647C329.53 273.293 328.354 274.784 326.708 274.979C326.591 274.993 326.473 275 326.356 275H161.036C159.499 275 158.21 273.838 158.052 272.31L146.016 156.31C145.845 154.662 147.043 153.187 148.691 153.016C148.793 153.005 148.897 153 149 153Z",
    fill: "#DCE1FD"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_44_536)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153 60C153 55.5817 156.582 52 161 52H199C203.418 52 207 55.5817 207 60V98C207 102.418 203.418 106 199 106H161C156.582 106 153 102.418 153 98V60Z",
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162 67H193.859L189.359 71.5H162V67Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162 77.5H183.359L178.859 82H162V77.5Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162 88H177.359V92.5H162V88Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.689 80.4239L186.98 89.1345L183.091 89.8416L183.798 85.9525L192.508 77.2426L195.689 80.4239ZM198.342 74.591C199.22 75.4697 199.22 76.8943 198.342 77.773L196.75 79.3633L193.569 76.182L195.16 74.591C196.038 73.7123 197.463 73.7123 198.342 74.591Z",
    fill: "#70CDEA"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_44_536)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 133,
    width: 77,
    height: 77,
    rx: 8,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.951 167.725L80.3333 196.412H39.5686L59.951 167.725Z",
    fill: "#C14DEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5785 167.726C84.1646 167.726 87.8824 164.008 87.8824 159.422C87.8824 154.835 84.1646 151.118 79.5785 151.118C74.9923 151.118 71.2745 154.835 71.2745 159.422C71.2745 164.008 74.9923 167.726 79.5785 167.726Z",
    fill: "#FFB61A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.3334 175.275L95.4314 196.412H65.2354L80.3334 175.275Z",
    fill: "#D8D8D8"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_44_536)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262 41C262 36.5817 265.582 33 270 33H332C336.418 33 340 36.5817 340 41V103C340 107.418 336.418 111 332 111H270C265.582 111 262 107.418 262 103V41Z",
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274 57H287.886V63H274V57ZM294.057 57H307.943V63H294.057V57ZM314.114 57H328V63H314.114V57ZM274 45H307.943V51H274V45ZM274 69H287.886V75H274V69ZM294.057 69H307.943V75H294.057V69ZM314.114 69H328V75H314.114V69ZM274 81H287.886V87H274V81ZM294.057 81H307.943V87H294.057V81ZM314.114 81H328V87H314.114V81ZM274 93H287.886V99H274V93ZM294.057 93H307.943V99H294.057V93ZM314.114 93H328V99H314.114V93Z",
    fill: "#51D389"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.057 57H307.943V63H294.057V57ZM294.057 69H307.943V75H294.057V69ZM294.057 81H307.943V87H294.057V81ZM294.057 93H307.943V99H294.057V93Z",
    fill: "#D8D8D8"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_44_536)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95 187C95 182.582 98.5817 179 103 179H146C150.418 179 154 182.582 154 187V230C154 234.418 150.418 238 146 238H103C98.5817 238 95 234.418 95 230V187Z",
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.592 188.419C118.089 190.963 118.771 196.729 121.5 202.617C120.549 205.434 119.474 208.277 118.12 211.491C116.997 214.155 115.656 216.88 114.238 219.381C106.495 222.406 101.57 225.834 101.049 228.563C100.875 229.48 101.161 230.357 101.911 231.048C102.358 231.459 103.311 232 104.704 232C109.156 232 114.11 225.585 117.828 219.013C119.895 218.308 122.051 217.655 124.29 217.072C126.702 216.443 129.033 215.937 131.221 215.567C136.607 220.36 141.36 221.081 143.729 221.081C146.685 221.081 147.526 219.875 147.821 219.107C148.247 217.994 147.856 216.764 147.252 216.126C145.904 214.699 143.076 213.947 139.074 213.947C136.846 213.947 134.3 214.176 131.502 214.63C129.884 213.147 128.313 211.37 126.833 209.345C125.767 207.887 124.8 206.389 123.94 204.865C125.357 200.546 126.345 196.402 126.345 193.25C126.345 190.886 125.577 187 122.008 187C121.078 187 120.096 187.567 119.592 188.419ZM120.479 188.49C120.851 187.869 121.468 187.489 122.132 187.489C123.497 187.489 124.245 188.66 124.253 190.796C124.26 193.096 123.496 196.874 122.08 201.185C119.416 195.144 119.381 190.32 120.479 188.49ZM120.982 212.327C121.841 210.301 122.664 208.181 123.391 206.076C124.163 207.376 125.001 208.657 125.921 209.906C127.277 211.748 128.711 213.388 130.189 214.794L130.173 214.796L130.179 214.802C128.175 215.158 126.063 215.624 123.884 216.187C121.968 216.682 120.111 217.23 118.316 217.815C119.359 215.901 120.268 214.015 120.982 212.327ZM140.616 219.616C137.202 218.795 134.413 216.953 132.168 215.01C136.777 214.166 140.82 214.319 142.555 214.685C144.324 215.055 145.281 216.132 144.975 217.726C144.73 219.015 143.468 219.772 141.892 219.772C141.483 219.772 141.054 219.721 140.616 219.616ZM102.629 230.094C102.089 229.602 101.904 229.032 102.025 228.407C102.469 226.117 106.965 223.038 113.863 220.261C110.017 226.628 106.236 230.533 103.867 230.533C103.404 230.533 102.965 230.4 102.629 230.094Z",
    fill: "#E52037"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_44_536)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M373 104C373 99.5817 376.582 96 381 96H443C447.418 96 451 99.5817 451 104V166C451 170.418 447.418 174 443 174H381C376.582 174 373 170.418 373 166V104Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M401.5 108.018V124.5H416.482C416.091 132.85 409.197 139.5 400.75 139.5C392.052 139.5 385 132.448 385 123.75C385 115.052 392.052 108 400.75 108C401.001 108 401.251 108.006 401.5 108.018Z",
    fill: "#FF741A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439 147H385V151.5H439V147Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M422.314 135H439V139.5H417.814L422.314 135Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M403 106.5C411.35 106.891 418 113.785 418 122.232C418 122.484 417.994 122.734 417.982 122.982H403V106.5Z",
    fill: "#58A1FF"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_44_536)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326 154C326 149.582 329.582 146 334 146H383C387.418 146 391 149.582 391 154V203C391 207.418 387.418 211 383 211H334C329.582 211 326 207.418 326 203V154Z",
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M371.349 158.093L371.35 185.978C371.641 188.201 369.764 190.595 366.861 191.539C363.685 192.571 360.483 191.476 359.709 189.094C358.935 186.712 360.882 183.945 364.058 182.913C366.236 182.205 368.426 182.498 369.837 183.519L369.837 168.976L350.186 172.907L350.187 190.767C350.376 192.947 348.519 195.255 345.681 196.177C342.505 197.209 339.303 196.114 338.529 193.733C337.755 191.351 339.703 188.583 342.878 187.551C345.065 186.841 347.264 187.138 348.674 188.17L348.674 162.628L371.349 158.093Z",
    fill: "#FE7AEA"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44_536)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144 103C162.225 103 177 117.775 177 136C177 154.225 162.225 169 144 169C125.775 169 111 154.225 111 136C111 117.775 125.775 103 144 103ZM144 128.184C139.683 128.184 136.184 131.683 136.184 136C136.184 140.317 139.683 143.816 144 143.816C148.317 143.816 151.816 140.317 151.816 136C151.816 131.683 148.317 128.184 144 128.184Z",
    fill: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.738 125L136.497 133.277C136.252 134.042 136.12 134.857 136.12 135.704C136.12 140.059 139.611 143.59 143.917 143.59C147.281 143.59 150.148 141.434 151.24 138.414L175 146.688C170.514 159.68 158.291 169 143.917 169C125.737 169 111 154.093 111 135.704C111 131.96 111.611 128.359 112.738 125Z",
    fill: "url(#paint3_linear_44_536)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M262.198 214.754C248.63 205.569 238.991 199.074 233.284 195.272C227.606 191.488 214.107 183.298 192.833 170.731C189.941 169.059 188.16 165.973 188.16 162.633V113.223C188.16 109.844 189.983 106.727 192.928 105.07L235.077 81.3614C237.89 79.779 241.32 79.7586 244.152 81.3071L264.711 92.5486L265.304 92.8746L287.06 105.071C290.012 106.726 291.84 109.846 291.84 113.231V162.571C291.84 165.951 290.017 169.068 287.072 170.724L269.966 180.346C269.021 180.878 268.006 181.233 266.968 181.412C265.976 181.582 264.963 181.592 263.969 181.44C264.75 182.102 265.423 182.862 265.979 183.692C267.444 185.882 268.09 188.566 267.719 191.253L264.273 216.158L262.198 214.754ZM268.293 183.333C269.235 183.087 270.154 182.719 271.025 182.229L288.131 172.607C291.756 170.568 294 166.731 294 162.571V113.231C294 109.065 291.75 105.224 288.116 103.187L266.353 90.9863L265.752 90.6561L259.553 87.2681L245.188 79.412C241.703 77.5059 237.481 77.5311 234.018 79.4787L191.869 103.188C188.244 105.227 186 109.063 186 113.223V162.633C186 166.74 188.188 170.537 191.742 172.596C213.027 185.169 226.468 193.325 232.087 197.069C237.786 200.867 247.419 207.358 260.987 216.542L265.937 219.893L269.859 191.549C270.257 188.667 269.678 185.788 268.293 183.333ZM239.14 114.755L218.38 126.428L218.384 150.134C224.113 153.343 231.102 157.373 239.35 162.223L260.837 150.142L260.833 126.428L240.08 114.755C239.788 114.591 239.432 114.591 239.14 114.755ZM262.993 125.165L262.997 151.405L239.324 164.716L239.318 164.71C230.376 159.444 222.885 155.124 216.843 151.748L216.224 151.402L216.219 125.165L238.081 112.872C239.031 112.338 240.19 112.338 241.139 112.872L262.993 125.165Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.665 124.255V152.319C221.158 155.923 229.472 160.713 239.606 166.69C242.941 168.656 246.164 170.667 249.274 172.722C270.78 186 265.941 192.739 264.151 205.666L263.072 213.462C249.501 204.276 239.86 197.779 234.149 193.974C228.438 190.168 214.926 181.971 193.613 169.381C191.203 167.988 189.719 165.416 189.719 162.632V138.287L214.665 124.255Z",
    fill: "url(#paint4_linear_44_536)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.719 113.223C189.719 110.407 191.238 107.81 193.693 106.429L235.842 82.7203C238.186 81.4017 241.044 81.3847 243.404 82.6751L264.556 94.2426V124.255L241.903 111.513C240.48 110.712 238.741 110.712 237.317 111.513L198.323 133.447C194.648 135.807 192.28 138.086 191.22 140.285L191.078 140.599C190.265 142.306 189.815 144.25 189.73 146.429L189.718 146.894L189.719 113.223Z",
    fill: "url(#paint5_linear_44_536)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.556 103.987C264.556 100.037 263.735 96.9082 262.093 94.6001L261.827 94.2424C260.853 92.8782 259.659 91.7333 258.246 90.8076L257.781 90.5162L264.556 94.2424L286.297 106.431C288.757 107.81 290.281 110.41 290.281 113.231V162.571C290.281 165.387 288.762 167.985 286.307 169.365L269.202 178.987C266.805 180.336 263.874 180.321 261.49 178.948L239.61 166.351L264.556 152.319V103.987Z",
    fill: "url(#paint6_linear_44_536)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M288.73 136.481L288.731 137.604C287.268 139.083 285.393 140.696 283.107 142.444C278.673 145.835 273.071 149.405 266.299 153.155L266.11 153.235L266.109 152.364L268.125 151.236C273.885 147.953 278.722 144.816 282.634 141.825C285.2 139.863 287.232 138.08 288.73 136.481Z",
    fill: "url(#paint7_linear_44_536)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M223.34 99.9368C228.494 102.082 235.894 106.041 243.278 110.497C240.966 109.336 240.267 109.396 239.648 109.356C234.788 106.116 227.643 102.572 223.04 100.657C218.613 98.814 215.116 97.7918 212.563 97.5855L213.717 96.9358C216.232 97.3113 219.437 98.3125 223.34 99.9368Z",
    fill: "url(#paint8_linear_44_536)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M213.108 153.168L214.08 153.776C213.995 161.825 214.151 169.141 214.635 175.103C214.758 176.619 214.896 178.045 215.048 179.38L214.028 179.265C213.907 178.137 213.796 176.951 213.695 175.705C213.196 169.56 213.008 161.481 213.108 153.168Z",
    fill: "url(#paint9_linear_44_536)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M244.152 81.3071L258.517 89.1632L264.711 92.5486L265.304 92.8746L287.06 105.071C290.012 106.726 291.84 109.846 291.84 113.231V162.571C291.84 165.951 290.017 169.068 287.072 170.724L269.966 180.346C268.11 181.39 265.987 181.753 263.946 181.437L263.683 181.206C266.712 183.604 268.248 187.425 267.719 191.253L264.616 213.676L264.273 216.158L262.198 214.754C248.63 205.569 238.991 199.074 233.284 195.272C227.606 191.488 214.107 183.298 192.833 170.731C189.941 169.059 188.16 165.973 188.16 162.633V113.223C188.16 109.844 189.983 106.727 192.928 105.07L235.077 81.3614C237.89 79.7791 241.32 79.7586 244.152 81.3071ZM213.106 126.92L200.479 134.015L199.165 134.759C195.711 136.977 193.537 139.07 192.639 140.93L192.485 141.269C191.767 142.778 191.365 144.515 191.288 146.469L191.276 146.934L191.278 162.633C191.278 164.742 192.344 166.7 194.106 167.854L194.406 168.039C215.745 180.644 229.27 188.849 235.013 192.677L235.392 192.929C240.766 196.513 249.415 202.339 261.34 210.408L261.869 210.766L264.63 190.826C264.991 188.217 264.008 185.611 262.036 183.891L261.748 183.651C254.818 178.169 247.174 172.963 238.814 168.033C228.69 162.063 220.388 157.279 213.908 153.682L213.106 153.237V126.92ZM264.709 96.115L264.833 96.4094C265.692 98.5493 266.115 101.079 266.115 103.987V153.231L265.32 153.678L242.761 166.366L262.268 177.597C264.063 178.631 266.246 178.702 268.095 177.807L268.438 177.628L285.543 168.007C287.507 166.902 288.722 164.824 288.722 162.571V113.231C288.722 110.975 287.503 108.894 285.535 107.791L264.709 96.115ZM238.081 112.872L216.219 125.165L216.224 151.402L216.843 151.748C222.885 155.124 230.376 159.444 239.318 164.71L239.324 164.716L262.997 151.405L262.993 125.165L241.139 112.872C240.19 112.338 239.031 112.338 238.081 112.872ZM236.606 84.0791L194.457 107.788C192.493 108.892 191.278 110.97 191.278 113.223L191.275 137.354L191.477 137.111C192.787 135.568 194.624 134.024 197 132.452L197.558 132.088L236.553 110.154C238.451 109.086 240.769 109.086 242.668 110.154L262.995 121.587L262.997 103.987C262.997 100.553 262.342 97.8555 261.085 95.8905L260.842 95.5307L260.559 95.1487C259.697 93.942 258.644 92.9318 257.418 92.1287L257.234 92.0117L242.656 84.043C240.768 83.0106 238.481 83.0242 236.606 84.0791Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M183.5 203H349.149C350.53 203 351.649 204.119 351.649 205.5C351.649 205.629 351.637 205.758 351.617 205.886L330.133 273.34L330.121 273.374L330.115 273.409C329.915 274.615 328.872 275.5 327.649 275.5H162C160.619 275.5 159.5 274.381 159.5 273C159.5 272.87 159.511 272.741 159.531 272.613L181.016 205.16L181.028 205.126L181.034 205.091C181.234 203.885 182.277 203 183.5 203Z",
    fill: "url(#paint10_linear_44_536)",
    stroke: "url(#paint11_linear_44_536)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_44_536",
    x: 138,
    y: 45,
    width: 84,
    height: 84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.355204 0 0 0 0 0.605312 0 0 0 0 0.758789 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_44_536"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_44_536",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_44_536",
    x: 14,
    y: 126,
    width: 107,
    height: 107,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.355204 0 0 0 0 0.605312 0 0 0 0 0.758789 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_44_536"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_44_536",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_44_536",
    x: 247,
    y: 26,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.355204 0 0 0 0 0.605312 0 0 0 0 0.758789 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_44_536"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_44_536",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_44_536",
    x: 80,
    y: 172,
    width: 89,
    height: 89,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.355204 0 0 0 0 0.605312 0 0 0 0 0.758789 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_44_536"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_44_536",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_44_536",
    x: 358,
    y: 89,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.355204 0 0 0 0 0.605312 0 0 0 0 0.758789 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_44_536"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_44_536",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_44_536",
    x: 311,
    y: 139,
    width: 95,
    height: 95,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.355204 0 0 0 0 0.605312 0 0 0 0 0.758789 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_44_536"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_44_536",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_44_536",
    x1: 255.862,
    y1: 52.2206,
    x2: 239.809,
    y2: 273.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#E9ECFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#E9ECFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_44_536",
    x1: 236,
    y1: -17,
    x2: 239.809,
    y2: 311.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789512,
    stopColor: "#E9ECFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_44_536",
    x1: 246.5,
    y1: 5,
    x2: 252,
    y2: 373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.290237,
    stopColor: "#E9ECFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769975,
    stopColor: "#E9ECFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_44_536",
    x1: 3311,
    y1: 1779,
    x2: 6316.45,
    y2: 2863.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DABF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBFFFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_44_536",
    x1: 190.193,
    y1: 133.851,
    x2: 263.666,
    y2: 207.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5360E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#7E88F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81D3FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_44_536",
    x1: 266.492,
    y1: 99.9412,
    x2: 184.542,
    y2: 125.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4756E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "#C4A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDDCFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_44_536",
    x1: 269.317,
    y1: 99.941,
    x2: 264.945,
    y2: 179.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCD9FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#BEA8F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A51EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_44_536",
    x1: 288.6,
    y1: 138.48,
    x2: 271.607,
    y2: 155.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_44_536",
    x1: 213,
    y1: 95.2799,
    x2: 232.438,
    y2: 115.539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_44_536",
    x1: 215.233,
    y1: 178.573,
    x2: 210.415,
    y2: 160.272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_44_536",
    x1: 255.575,
    y1: 202.5,
    x2: 255.575,
    y2: 276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_44_536",
    x1: 255.575,
    y1: 202.5,
    x2: 255.575,
    y2: 276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44_536"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    fill: "white",
    transform: "translate(111 103)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationCloudSpace);
export default __webpack_public_path__ + "static/media/illustration-cloud-space.65f626c74dbeca4de325493d705a0fdf.svg";
export { ForwardRef as ReactComponent };